import React from "react";
import { Tooltip, Button } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import "./floatingWhatsApp.css"; 

const FloatingWhatsApp = () => {
  return (
    <div className="floating-whatsapp">
      <Tooltip title="Chat on WhatsApp" placement="left">
        <a
          href="https://wa.me/+971568600147" 
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            type="primary"
            shape="circle"
            icon={<WhatsAppOutlined />}
            size="large"
            style={{ backgroundColor: "#25D366", borderColor: "#25D366", fontSize: "42px" }}
          />
        </a>
      </Tooltip>
    </div>
  );
};

export default FloatingWhatsApp;
